var mentions_default = {
  "mentionPalette": "_6T5DB",
  "mention": "hKrJC",
  "mentionViewer": "_1GDhK",
  "mentionSuggestionsEntry": "EWsh1",
  "mentionSuggestionsEntryFocused": "dFcWy",
  "mentionSuggestionsEntryText": "eyF4B",
  "mentionSuggestionsEntryAvatar": "Jsgg6",
  "mentionSuggestions": "RCrUc",
  "cursorDefault": "dLgWg",
  "cursorPointer": "pQT-A"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
